import { Card, Flex, Typography } from "antd";
import type { ReactNode } from "react";

/** Centered card for the pages outside the panel: sign-in, invitation, second factor setup. */
export function AuthCard({ title, children }: { title: string; children: ReactNode }) {
  return (
    <Flex justify="center" align="center" style={{ minHeight: "100vh", padding: 16 }}>
      <Card style={{ width: "100%", maxWidth: 420 }}>
        <Typography.Text type="secondary">HedefUni Office</Typography.Text>
        <Typography.Title level={3} style={{ marginTop: 4 }}>
          {title}
        </Typography.Title>
        {children}
      </Card>
    </Flex>
  );
}
